ApiAjax = require 'network/api-ajax'
Promise = require 'bluebird'
f = require 'effing'
_ = require 'underscore'
assert = require 'lib/assert'
ApiError = require 'network/api-error'

module.exports = (args) ->
  assert 'success' !of args && 'error' !of args, "This is promise country!"

  Promise.fromNode f(ApiAjax, args)
  .catch ([xhr]) ->
    Promise.reject ApiError.fromResponse(xhr.status, xhr.responseText)
  .get 0



// WEBPACK FOOTER //
// ./app/scripts/network/api-promise.coffee